import Burger from './Burger';

document.addEventListener('DOMContentLoaded', () => {
  const burgerWrapper = document.querySelector('.js-burger');
  if (!burgerWrapper) return;

  const control = burgerWrapper.querySelector('.js-burger-control');
  const target = burgerWrapper.querySelector('.js-burger-target');
  const label = burgerWrapper.querySelector('.js-burger-label');
  if (!control || !target) return;

  const burger = new Burger(burgerWrapper);

  function checkWindowWidth() {
    if (window.innerWidth <= 1150) {
      burger.mount();
    } else {
      burger.unmount();
      document.querySelector('header').classList.remove('is-open');
      document.querySelector('.c-header__navigation-wrapper').removeAttribute('hidden');
    }
  }

  checkWindowWidth();

  window.addEventListener('resize', checkWindowWidth);
});
